import { FieldArray, useFormikContext } from 'formik';
import { isLoseWare } from '../../../helper/bestellungen-helper';
import { ArtikelTableValues } from '../../../types';
import { selectIsBestellungExisting } from '../../../../store/Global.selectors';
import { useSelector } from 'react-redux';
import { LoseWareListEntryExistingBestellung } from './ExistingBestellung/LoseWareListEntryExistingBestellung';
import { LoseWareListEntryNewBestellung } from './NewBestellung/LoseWareListEntryNewBestellung';

interface LoseWareListProps {
    onArtikelDeleted?: (artikelNummer: string) => void;
}

export const LoseWareList = ({ onArtikelDeleted }: LoseWareListProps): JSX.Element => {
    const formikProps = useFormikContext<ArtikelTableValues>();
    const isExisting = useSelector(selectIsBestellungExisting);

    const ListEntry = isExisting ? LoseWareListEntryExistingBestellung : LoseWareListEntryNewBestellung;

    const filteredPositions = formikProps.values.bestellpositionenView
        .filter(isLoseWare)
        .filter((position) => position.nummer && position.nummer.trim() !== ''); // Filter out positions ohne artikelnummer

    return (
        <div>
            <FieldArray
                name="bestellpositionenView"
                render={(arrayHelpers): JSX.Element => (
                    <>
                        {filteredPositions.map((bestellposition) => {
                            return (
                                <ListEntry
                                    key={`${bestellposition.index}-${bestellposition.nummer}`}
                                    bestellposition={bestellposition}
                                    arrayHelpers={arrayHelpers}
                                    onArtikelDeleted={onArtikelDeleted}
                                />
                            );
                        })}
                    </>
                )}
            />
        </div>
    );
};
